export const checkNewRelicOnWindow = (): boolean =>
  !!(typeof window !== 'undefined' && window.newrelic)

export const setNewRelicCustomAttribute = (key: string, value: string): void => {
  if (checkNewRelicOnWindow()) {
    window.newrelic.setCustomAttribute(key, value)
  }
}
